module.exports = __webpack_public_path__ + "img/cloth_g3_item-13.6be5a6c5.svg";